module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_mouth_width.0108e129.png";